/* Mobile product reading space. Existing forms, prices, translations and
   announcements remain the source of truth; desktop uses the original theme. */
(function () {
  'use strict';
  var mobile = matchMedia('(max-width: 749px)');
  var header, main, announcement, originalPlace, host, pending, bar;
  var lastY = scrollY, direction = 0, travel = 0, keepUntil = 0;
  function setClass(element, name, on) {
    if (element.classList.contains(name) !== on) element.classList.toggle(name, on);
  }
  function setVariable(name, value) {
    if (document.documentElement.style.getPropertyValue(name) !== value) {
      document.documentElement.style.setProperty(name, value);
    }
  }
  function visible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect(), style = getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight &&
      style.display !== 'none' && style.visibility !== 'hidden';
  }
  function blockingOverlay() {
    return /overflow-hidden|js-drawer-open/.test(document.body.className + ' ' + document.documentElement.className) ||
      !!document.querySelector('#CartDrawer.drawer--is-open, #NavDrawer.drawer--is-open, cart-drawer.active') ||
      Array.prototype.some.call(document.querySelectorAll('#shopify-section-header details[open], #shopify-section-header [aria-expanded="true"]'), visible) ||
      visible(document.getElementById('shopify-pc__prefs__dialog')) ||
      visible(document.querySelector('#EzspaMelding.ezspa-melding--zichtbaar'));
  }
  function headerState() {
    var y = Math.max(0, scrollY), delta = y - lastY;
    lastY = y;
    if (!mobile.matches || y < 80 || blockingOverlay() || Date.now() < keepUntil) {
      setClass(document.body, 'mp-header-hidden', false);
      travel = 0; direction = 0;
      return;
    }
    if (Math.abs(delta) < 1) return;
    var nextDirection = delta > 0 ? 1 : -1;
    if (nextDirection !== direction) { direction = nextDirection; travel = 0; }
    travel += Math.abs(delta);
    if (travel >= (direction > 0 ? 24 : 12)) {
      setClass(document.body, 'mp-header-hidden', direction > 0);
      travel = 0;
    }
  }
  function measure() {
    pending = false;
    headerState();
    if (!header || !bar) return;
    if (!mobile.matches) {
      bar.classList.remove('mp-buy-visible');
      document.body.classList.remove('mp-wa-visible');
      return;
    }
    setVariable('--mp-header-height', header.offsetHeight + 'px');
    setVariable('--mp-buybar-height', bar.offsetHeight + 'px');
    var top = Math.max(0, header.getBoundingClientRect().bottom);
    var anotherBuy = Array.prototype.some.call(main.querySelectorAll('form[action*="/cart/add"] button[type="submit"], .pdp-knop'), function (button) {
      if (bar.contains(button)) return false;
      var rect = button.getBoundingClientRect();
      return visible(button) && rect.bottom > top + 8 && rect.top < innerHeight - 8;
    });
    setClass(bar, 'mp-buy-visible', anotherBuy);
    var buybarVisible = bar.classList.contains('aan') && !anotherBuy &&
      getComputedStyle(bar).position === 'fixed' && visible(bar);
    setClass(document.body, 'mp-wa-visible', buybarVisible && !blockingOverlay() &&
      !visible(document.getElementById('shopify-pc__banner')) &&
      !visible(document.querySelector('[data-cookiebalk]')));
  }
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(measure, 80);
  }
  function resizeAnnouncement() {
    if(!mobile.matches || !announcement || !host) return;
    var slider=announcement.querySelector('.announcement-slider');
    if(slider && window.Flickity && typeof window.Flickity.data==='function'){
      var flickity=window.Flickity.data(slider);
      if(flickity) flickity.resize();
    }
  }
  function arrange() {
    header = document.querySelector('#shopify-section-header .site-header');
    main = document.getElementById('MainContent');
    bar = document.querySelector('[data-koopbalk]');
    if (!header || !main || !bar) return;
    if (!announcement || !announcement.isConnected) {
      announcement = document.querySelector('#shopify-section-header .announcement-bar');
      if (announcement) {
        originalPlace = document.createComment('Original desktop announcement position');
        announcement.parentNode.insertBefore(originalPlace, announcement);
      }
    }
    if (mobile.matches && announcement) {
      var section = main.querySelector('.pdp');
      section = section && section.closest('.shopify-section');
      if (section) {
        host = main.querySelector('.mp-inline-announcement');
        if (!host) {
          host = document.createElement('div');
          host.className = 'mp-inline-announcement';
          section.insertAdjacentElement('afterend', host);
        }
        if (announcement.parentNode !== host) {
          host.appendChild(announcement);
          requestAnimationFrame(resizeAnnouncement);
        }
      }
    } else {
      if (announcement && originalPlace && originalPlace.parentNode && announcement.previousSibling !== originalPlace) {
        originalPlace.parentNode.insertBefore(announcement, originalPlace.nextSibling);
      }
      if (host) { host.remove(); host = null; }
    }
    measure();
  }
  function init() {
    arrange();
    if (!header || !bar) return;
    new MutationObserver(schedule).observe(bar, { attributes: true, attributeFilter: ['class', 'style'] });
    new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true });
    new MutationObserver(schedule).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(header);
    document.addEventListener('toggle', schedule, true);
    document.addEventListener('visitorConsentCollected', schedule);
    document.addEventListener('click', function (event) {
      if (mobile.matches && event.target.closest('.ps-sprong a')) {
        keepUntil = Date.now() + 1200;
        setClass(document.body, 'mp-header-hidden', false);
        direction = 0; travel = 0;
      }
      schedule();
    }, true);
    document.addEventListener('focusin', function (event) {
      if (event.target.closest('#shopify-section-header')) {
        keepUntil = Date.now() + 1200;
        setClass(document.body, 'mp-header-hidden', false);
      }
    });
    document.addEventListener('shopify:section:load', arrange);
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', function(){schedule();resizeAnnouncement();});
    addEventListener('load', resizeAnnouncement, {once:true});
    addEventListener('pageshow', arrange);
    if (mobile.addEventListener) mobile.addEventListener('change', arrange);
    else mobile.addListener(arrange);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
